"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("./enum");
const subscriptionSchema = new mongoose_1.Schema({
    initial_start_date: {
        type: String,
        required: true,
    },
    team_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "Team",
    },
    admin_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        required: true,
        ref: "User",
    },
    billable_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        required: true,
        ref: "User",
    },
    project_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        required: false,
        ref: "Project",
        default: null,
    },
    plan_type: {
        type: String,
        enum: Object.values(enum_1.SUBSCRIPTION_PLAN_TYPE),
        default: enum_1.SUBSCRIPTION_PLAN_TYPE.FreePlan,
    },
    status: {
        type: String,
        enum: Object.values(enum_1.SUBSCRIPTION_STATUS),
        default: enum_1.SUBSCRIPTION_STATUS.ACTIVE,
    },
    grafana_org_id: String,
    specifications: {
        type: Object,
        default: {},
        select: true,
    },
    amount: Number,
    debit_date: String,
    start_date: String,
    expiry_date: String,
    reminder_date: String,
    transaction_retries: Number,
    is_pending_downgrade: {
        type: Boolean,
        default: false,
    },
    disabled_at: {
        required: false,
        type: Date
    },
    trigger_created: {
        type: Boolean,
        default: false,
    },
    trigger_created_at: {
        type: String,
    },
    job_identifier: {
        type: String,
    },
}, {
    timestamps: true,
    collection: "subscriptions",
});
exports.default = (0, mongoose_1.model)("Subscription", subscriptionSchema);
